// <Shopify Product Id Number>, <Partner Price Number>
const partnerProducts = new Map();

const buildPartnerPricing = () => {

    // Phantom
    partnerProducts.set(6596657021005, 1299.00);

    // Silver
    partnerProducts.set(7244906070093, 799.00);

    // Shield
    partnerProducts.set(7402648240205, 325.00);

    // Filtered Earplugs
    partnerProducts.set(6596640211021, 225.00);

    // Solid Earplugs
    partnerProducts.set(6596654563405, 149.00);

    // High Frequency Earplugs
    partnerProducts.set(6596641325133, 150.00);

    // Tunz Duo S
    partnerProducts.set(7242189570125, 199.00);

    // Tunz Duo
    partnerProducts.set(7242183639117, 149.00);

    // Tunz Solo
    partnerProducts.set(7242168041549, 139.00);

    // Swim Earplugs
    partnerProducts.set(7402644865101, 149.00);

    // Sleeping Earplugs
    partnerProducts.set(7403160207437, 149.00);
}

// <Partner param code>, <Partner info>
const partnerInfo = new Map();

const buildPartnerInfo = () => {
    partnerInfo.set("pheasants-forever", {
        clubName: "Pheasants Forever",
        logoSrc: "/cdn/shop/files/pheasants-forever-logo.svg",
        logoWidth: 250,
        logoHeight: 250
    });

    partnerInfo.set("delta-waterfowl", {
        clubName: "Delta Waterfowl",
        logoSrc: "/cdn/shop/files/logo-delta-waterfowl.svg",
        logoWidth: 250,
        logoHeight: 250
    });

    partnerInfo.set("hms-motorsport", {
        clubName: "HMS Motorsport",
        logoSrc: "/cdn/shop/files/logo-hms-motorsport.svg",
        logoWidth: 250,
        logoHeight: 250
    });

    partnerInfo.set("jgr", {
        clubName: "Joe Gibbs Racing",
        logoSrc: "/cdn/shop/files/jgr-block-logo.svg",
        logoWidth: 250,
        logoHeight: 250
    });

    partnerInfo.set("trd", {
        clubName: "Toyota Racing Development",
        logoSrc: "/cdn/shop/files/logo-trd.svg",
        logoWidth: 250,
        logoHeight: 250
    });

    partnerInfo.set("onx-hunt", {
        clubName: "Onx Hunt",
        logoSrc: "/cdn/shop/files/logo-onx-hunt.svg",
        logoWidth: 250,
        logoHeight: 250
    });

    partnerInfo.set("fsa", {
        clubName: "Florida Sheriffs Association",
        logoSrc: "/cdn/shop/files/logo-florida-sheriffs-association.png",
        logoWidth: 378,
        logoHeight: 173
    });

    partnerInfo.set("mcsa", {
        clubName: "Major County Sheriffs of America",
        logoSrc: "/cdn/shop/files/logo-mcsa.png",
        logoWidth: 250,
        logoHeight: 250
    });

    partnerInfo.set("nsa", {
        clubName: "National Sheriffs' Association",
        logoSrc: "/cdn/shop/files/logo-nsa-gold-partner.png",
        logoWidth: 200,
        logoHeight: 150
    });

    partnerInfo.set("zmax", {
        clubName: "ZMax Cars Tour",
        logoSrc: "/cdn/shop/files/logo-zmax-cars-tour.svg",
        logoWidth: 250,
        logoHeight: 250
    });

    partnerInfo.set("racing-electronics", {
        clubName: "Racing Electronics",
        logoSrc: "/cdn/shop/files/racing-electronics-logo.svg",
        logoWidth: 350,
        logoHeight: 200
    });

    partnerInfo.set("union-sportsmens-alliance", {
        clubName: "Union Sportsmen's Alliance",
        logoSrc: "/cdn/shop/files/union-sportsmens-alliance-logo.svg",
        logoWidth: 250,
        logoHeight: 250
    });

    partnerInfo.set("kalitta-motorsports", {
        clubName: "Kalitta Motorsports",
        logoSrc: "/cdn/shop/files/kalitta-motorsports-logo.svg",
        logoWidth: 250,
        logoHeight: 250
    });

  partnerInfo.set("nra", {
        clubName: "NRA",
        logoSrc: "/cdn/shop/files/nra-logo-sg.svg",
        logoWidth: 385,
        logoHeight: 139
    });
}

const url = new URL(window.location.href);
const params = new URLSearchParams(url.search);

const partnerFromParams = params.get("partner");
const partnerFromSession = sessionStorage.getItem("partner");

// Required to build partner information here because the partner-marquee.liquid section uses it as its SSOT - LM       
buildPartnerInfo();

if (partnerFromParams || partnerFromSession) {
    buildPartnerPricing();

    if (params.has("partner")) {
        sessionStorage.setItem("partner", partnerFromParams);
        window.history.replaceState({}, document.title.textContent, window.location.pathname);
    }
}